import { AuthService } from './../../login/auth.service';
import { MasterService } from './../services/master.service';
import { Component, OnInit, Input, ViewChild, signal, computed, HostListener } from '@angular/core';
import { ProfileModalComponent } from './../profile-modal/profile-modal.component';
import { ChangePasswordModalComponent } from './../change-password-modal/change-password-modal.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSidenav } from '@angular/material/sidenav';
import { UserService } from '../services/user.service';
import { UserCacheService } from '../services/user-cache.service'; // Import the UserCacheService

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss', '../../app.component.scss']
})
export class HeaderComponent implements OnInit {
  public showMoreFlag = false;
  public showScannedFlag = false;
  public userId: any;
  public token: any;
  public dashboardPermission = false;
  public purchaseOrderPermission = false;
  public invoicePermission = false;
  public stocksPermission = false;
  public trackingPermission = false;
  public active_implantsPermission = false;
  public accepted_implantsPermission = false;
  public rejected_implantsPermission = false;
  public missing_implantsPermission = false;
  public scanned_implantsPermission = false;
  public morePermission = false;
  public implantClassificationPermission = false;
  public bodyPartsPermission = false;
  public implantsPermission = false;
  public productCategoriesPermission = false;
  public productsPermission = false;
  public regionsTopPermission = false;
  public regionsPermission = false;
  public countriesPermission = false;
  public citiesPermission = false;
  public antennasPermission = false;
  public storePermission = false;
  public usersTopPermission = false;
  public usersPermission = false;
  public userRolesPermission = false;
  public bulk_uploadTopPermission = false;
  public bulk_upload_bodyPartsPermission = false;
  public bulk_upload_implantsPermission = false;
  public bulk_upload_productCategoriesPermission = false;
  public bulk_upload_productsPermission = false;
  public bulk_upload_purchaseOrderPermission = false;
  public bulk_upload_invoicePermission = false;
  public bulk_upload_rfid1Permission = false;
  public bulk_upload_rfid2Permission = false;
  public settingTopPermission = false;
  public settingAndroidPermission = false;
  public settingReportsPermission = false;
  public analyticsViewPermission = false;

  public name: '';

  showSubmenu1 = false;
  showSubmenu2 = false;
  showSubmenu3 = false;
  showSubmenu4 = false;
  showSubmenu5 = false;
  showSubmenu6 = false;
  user: any;
  roleName: string = '';
  isNotificationDropdownOpen = false;
  isAlertsDropdownOpen = false;
  isNotificationsDropdownOpen = false;

  constructor(
    public masterservice: MasterService,
    private userService: UserService,
    private userCacheService: UserCacheService,
    public dialog: MatDialog,
    public route: Router,
    private router: Router,
    public masterService: MasterService,
    public authService: AuthService
  ) {}

  @ViewChild('drawer', { static: false })
  drawer: MatSidenav;

  collapse = signal(false);
  isHamburgerIcon = signal(false);
  onHamburgerIcon = signal(true);

  onEnterHamburger(event) {
    event.stopPropagation();
  }

  onHamburger() {
    this.collapse.set(!this.collapse());
    this.onHamburgerIcon.set(!this.collapse());
  }

  sideBarExpand() {
    if (this.collapse()) {
      this.collapse.set(false);
      this.onHamburgerIcon.set(false);
    }
  }

  sideBarCollapsed() {
    if (!this.collapse() && !this.onHamburgerIcon()) {
      this.collapse.set(true);
    }
  }

  ngOnInit() {
    const userId = localStorage.getItem('userId');
    const cachedUser = this.userCacheService.getUserDetails();

    if (cachedUser) {
      this.user = cachedUser.data;
      if (this.user.roles && this.user.roles.length > 0) {
        this.roleName = this.user.roles[0].name;
      }
    } else {
      this.userCacheService.fetchUserDetails(userId).subscribe((data: any) => {
        this.user = data.data;
        if (this.user.roles && this.user.roles.length > 0) {
          this.roleName = this.user.roles[0].name;
        }
      });
    }
  }

  // ngOnInit() {
  //   // this.token = localStorage.getItem('token');
  //   const userId = localStorage.getItem('userId');
  //   this.userService.getUserDetails(userId).subscribe((data: any) => {
  //     this.user = data.data;
  //     if (this.user.roles && this.user.roles.length > 0) {
  //       this.roleName = this.user.roles[0].name;
  //     }
  //   });
  // }

  showMore() {
    this.route.navigate(['/home/bodyparts']);
    this.showMoreFlag = true;
    this.showScannedFlag = false;
  }

  navigateUrl(url) {
    this.showMoreFlag = false;
    this.route.navigate([url]);
    this.showScannedFlag = false;
  }

  editProfile() {
    const dialogRef = this.dialog.open(ProfileModalComponent, {
      minWidth: '50vw',
      minHeight: '20vh',
      disableClose: true,
      data: {}
    });
  }

  changePassword() {
    const dialogRef = this.dialog.open(ChangePasswordModalComponent, {
      minWidth: '50vw',
      minHeight: '20vh',
      disableClose: true,
      data: {}
    });
  }

  logoutCurrent() {
    const data = {
      token: this.token
    };
    this.authService.logout(data).subscribe(res => {
      localStorage.clear();
      this.route.navigateByUrl(`/login`);
    });
  }

  showSubmenu(e) {
    if (e === 1) {
      this.showSubmenu1 = !this.showSubmenu1;
      this.showSubmenu2 = false;
      this.showSubmenu3 = false;
    } else if (e === 2) {
      this.showSubmenu2 = !this.showSubmenu2;
      this.showSubmenu1 = false;
      this.showSubmenu3 = false;
    } else if (e === 3) {
      this.showSubmenu3 = !this.showSubmenu3;
      this.showSubmenu1 = false;
      this.showSubmenu2 = false;
    }
  }

  closeSubmenu() {
    this.showSubmenu1 = false;
    this.showSubmenu2 = false;
    this.showSubmenu3 = false;
    this.showSubmenu4 = false;
    this.showSubmenu5 = false;
    this.showSubmenu6 = false;
  }

  toggleNotificationDropdown() {
    this.isNotificationDropdownOpen = !this.isNotificationDropdownOpen;
  }

  toggleAlertsDropdown() {
    this.isAlertsDropdownOpen = !this.isAlertsDropdownOpen;
    // Close other dropdowns
    this.isNotificationsDropdownOpen = false;
  }

  toggleNotificationsDropdown() {
    this.isNotificationsDropdownOpen = !this.isNotificationsDropdownOpen;
    // Close other dropdowns
    this.isAlertsDropdownOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    // Check if click is outside the dropdown containers
    const target = event.target as HTMLElement;
    const alertsContainer = target.closest('.alerts-dropdown-container');
    const notificationsContainer = target.closest('.notifications-dropdown-container');
    
    if (!alertsContainer && !notificationsContainer) {
      this.isAlertsDropdownOpen = false;
      this.isNotificationsDropdownOpen = false;
    }
  }

  navigateToProfilePage() {
    this.router.navigate(['/home/myprofile']);
  }
}
